import { Outlet } from "react-router-dom";

/**
 * Knowledge pages render inside the Agents shell. Module links live in the left
 * rail (Knowledge base, Libraries, Books, Articles).
 */
export function KnowledgeLayout() {
  return (
    <div className="space-y-6">
      <Outlet />
    </div>
  );
}
